<template>
      <div class="root" style="flex-grow: 1; position: relative;">
        <a
          class="button is-small is-pulled-right"
          :onclick="'window.open(\'' + etherpadLink + '\',\'newwindow\',\'width=1600,height=900\')'"
          style="position: absolute; top:30px; right: 0;"
        >
          <i class="fa fa-eye"></i>
        </a>
        <iframe
          class="pad"
          ref="iframe"
          :src="etherpadLink"
          :style="style"
        ></iframe>
      </div>
    </template>

    <script>
    import settings from '@/settings.coffee'

    export default {
      name: "EtherPad",
      props: {
        padkey: String,
        height: String
      },
      computed: {
        style() {
          return {
            height: this.height
          }
        },
        etherpadLink() {
          return (
            settings.etherpadUrl +
            this.padkey +
            "?toc=true&noColors=true&showControls=true&showLineNumbers=false&userName=" +
            encodeURI(this.$store.state.profile.data.fullname)
          )
        }
      }
    }
    </script>

    <style lang="scss" scoped>
    .pad {
      padding: 0;
      width: 100%;
    }
    </style>